import Vue from 'vue'
import hui from 'hui'
import './style/hui-reset.scss'
import './style/index.scss'
import './style/common.scss'
import initLogin from './loginPage/initLogin'
// 引入storage读取库
import storage from 'good-storage'
import lodash from 'lodash'
Vue.use(hui)
Vue.prototype.$lodash = lodash
Vue.prototype.$storage = storage

initLogin(Vue)
